/* global cascade */
function bindAnimationEquipeItem(idGrid) {
  const grid = document.querySelector(`#${idGrid}`) !== null ? document.querySelector(`#${idGrid}`) : null;

  if (grid !== null) {
    const { children } = grid;

    let timeout = 400;

    for (let i = 0; i < children.length; i += 1) {
      const el = children[i];

      const equipeFoto = el.querySelector('picture') !== null ? el.querySelector('picture') : null;
      const equipeNome = el.querySelector('.title') !== null ? el.querySelector('.title') : null;
      const equipeTexto = el.querySelector('.text') !== null ? el.querySelector('.text') : null;
      const equipeIndioma = el.querySelector('.langs') !== null ? el.querySelector('.langs') : null;
      const equipeLinkedin = el.querySelector('.-social') !== null ? el.querySelector('.-social') : null;

      setTimeout(() => {
        if (equipeFoto !== null) {
          equipeFoto.classList.add('slide-in-bottom');
        }

        setTimeout(() => {
          if (equipeNome !== null) {
            equipeNome.classList.add('slide-in-bottom');
          }

          setTimeout(() => {
            if (equipeTexto !== null) {
              equipeTexto.classList.add('slide-in-bottom');
            }

            setTimeout(() => {
              if (equipeIndioma !== null) {
                equipeIndioma.classList.add('slide-in-bottom');
              }

              setTimeout(() => {
                if (equipeLinkedin != null) {
                  equipeLinkedin.classList.add('slide-in-bottom');
                }
              }, 200);
            }, 200);
          }, 200);
        }, 200);
      }, timeout);

      timeout += 400;
    }
  }
}

function initializeEquipeAnim() {
  const hero = document.querySelector('#hero-equipe') !== null ? document.querySelector('#hero-equipe') : null;
  const title = document.querySelector('#title-hero') !== null ? document.querySelector('#title-hero') : null;
  const subtitle = document.querySelector('#subtitle-hero') !== null ? document.querySelector('#subtitle-hero') : null;
  const sociosTitle = document.querySelector('#socios-title') !== null ? document.querySelector('#socios-title') : null;
  const equipeTitle = document.querySelector('#equipe-title') !== null ? document.querySelector('#equipe-title') : null;
  const estagiariosTitle = document.querySelector('#estagiarios-title') !== null ? document.querySelector('#estagiarios-title') : null;

  const socios = document.querySelector('#socios') !== null ? document.querySelector('#socios') : null;
  const equipe = document.querySelector('#equipe') !== null ? document.querySelector('#equipe') : null;

  setTimeout(() => {
    title.classList.add('slide-in-bottom');

    setTimeout(() => {
      subtitle.classList.add('slide-in-bottom');
    }, 400);
  }, 300);

  function anim() {
    const scrollpos = window.scrollY;

    if (hero != null) {
      if (scrollpos >= (3 * (hero.offsetHeight / 5))) {
        if (sociosTitle !== null) {
          sociosTitle.classList.add('slide-in-bottom');
          bindAnimationEquipeItem('socios-itens');
        }
      }

      if (scrollpos >= (4 * (socios.offsetTop + socios.offsetHeight) / 5)) {
        bindAnimationEquipeItem('equipe-slider');
        equipeTitle.classList.add('slide-in-bottom');
      }

      if (scrollpos >= (4 * (equipe.offsetTop + equipe.offsetHeight) / 5)) {
        bindAnimationEquipeItem('estagiarios-slider');
        estagiariosTitle.classList.add('slide-in-bottom');
      }
    }
  }

  anim();

  window.addEventListener('scroll', () => {
    anim();
  });
}
document.addEventListener('DOMContentLoaded', initializeEquipeAnim);
